module.exports = __webpack_public_path__ + "img/temperature.105a0e4e.svg";